// Labels and colors for every status in the GRC domain. The API sends the same
// keys (enum names) and display labels; the colors live here, in one place.

export const TIER = {
  TIER_1: { label: "Tier 1 – Critical", short: "Tier 1", color: "#E5484D" },
  TIER_2: { label: "Tier 2 – High", short: "Tier 2", color: "#F97316" },
  TIER_3: { label: "Tier 3 – Moderate", short: "Tier 3", color: "#EAB308" },
  TIER_4: { label: "Tier 4 – Low", short: "Tier 4", color: "#22C55E" },
  UNASSIGNED: { label: "Not yet assessed", short: "Unrated", color: "#94A3B8" },
};

export const WORKFLOW = {
  AWAITING_RISK_ASSESSMENT: { label: "Awaiting Risk Assessment", color: "#94A3B8" },
  RISK_ASSESSMENT_COMPLETED: { label: "Risk Assessment Completed", color: "#06B6D4" },
  AWAITING_APPROVAL: { label: "Awaiting Approval", color: "#8B5CF6" },
  APPROVED: { label: "Approved", color: "#10B981" },
  REJECTED: { label: "Rejected", color: "#F43F5E" },
};

export const CONTROL = {
  IMPLEMENTED: { label: "Implemented", color: "#10B981" },
  PARTIALLY_IMPLEMENTED: { label: "Partially Implemented", color: "#F59E0B" },
  NOT_IMPLEMENTED: { label: "Not Implemented", color: "#EF4444" },
  NOT_APPLICABLE: { label: "Not Applicable", color: "#94A3B8" },
};

export const EVIDENCE = {
  CURRENT: { label: "Current", color: "#10B981" },
  EXPIRING_SOON: { label: "Expiring Soon", color: "#F59E0B" },
  EXPIRED: { label: "Expired", color: "#EF4444" },
  MISSING: { label: "Missing", color: "#64748B" },
};

export const RISK_LEVEL = {
  CRITICAL: { label: "Critical", color: "#DC2626" },
  HIGH: { label: "High", color: "#F97316" },
  MEDIUM: { label: "Medium", color: "#EAB308" },
  LOW: { label: "Low", color: "#22C55E" },
};

export const RISK_STATUS = {
  OPEN: { label: "Open", color: "#EF4444" },
  MITIGATING: { label: "Mitigating", color: "#F59E0B" },
  ACCEPTED: { label: "Accepted", color: "#64748B" },
  CLOSED: { label: "Closed", color: "#10B981" },
};

export const POLICY = {
  DRAFT: { label: "Draft", color: "#94A3B8" },
  IN_REVIEW: { label: "In Review", color: "#F59E0B" },
  APPROVED: { label: "Approved", color: "#10B981" },
  RETIRED: { label: "Retired", color: "#64748B" },
};

export const AUDIT = {
  PLANNED: { label: "Planned", color: "#94A3B8" },
  IN_PROGRESS: { label: "In Progress", color: "#3B82F6" },
  COMPLETED: { label: "Completed", color: "#10B981" },
};

export const FINDING_STATUS = {
  OPEN: { label: "Open", color: "#EF4444" },
  IN_PROGRESS: { label: "In Progress", color: "#F59E0B" },
  CLOSED: { label: "Closed", color: "#10B981" },
};

export const TIER_ORDER = ["TIER_1", "TIER_2", "TIER_3", "TIER_4"];
